import styles from './tab.module.css'
import {useEffect, useState} from "react";
import {UseTypes} from "../../../context/type";

const Tab = (props) =>
{
	const [{getName}] = UseTypes()
	const [getList, setList] = useState()
	let [getActive, setActive] = useState()
	useEffect(() => {
		setList(getName)
	}, [getList, getName])

	const getSelectedItem = (e) => {
		setActive(e.target.innerHTML);
		props.changeSelection(e.target.innerHTML)
	}

	const getSelectedOption = (e) => {
		setActive(e.target.value)
		props.changeSelection(e.target.value)
	}
	return (
		<>
			<ul className={styles.navBar}>
				{
					getList ? getList.map((item, index) => (<li key={index} className={getActive !== item ? styles.navItem : styles.navItem + ' ' + styles.select} value={item} onClick={getSelectedItem} >{item}</li>)) : ' '
				}
			</ul>

			<select className={styles.mNav} onChange={getSelectedOption}>
				{
					getList ? getList.map((item, index) => (<option value={item} key={index}>{item}</option>)) : ''
				}
			</select>
		</>
	)
}

export default Tab